import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GoalPickerScreen } from '../components/GoalPickerScreen.tsx';

export const Route = createFileRoute('/_funnel/start/goal')({
  component: FunnelGoalPage,
});

function FunnelGoalPage() {
  const navigate = useNavigate();
  return (
    <GoalPickerScreen eyebrow="Your scan" onPicked={() => navigate({ to: '/start/bioscan' })} />
  );
}
